import type { JourneyFilterId } from '../constants/status'

type Matchable = {
  uiStatus: string
  isNew: boolean
}

/**
 * Correspondência item ↔ filtro.
 *
 * `new` **não** é um `ResourceStatus`: é recência, eixo independente do
 * progresso. Por isso a correspondência é por predicado e não por comparação
 * direta com `uiStatus` — era essa comparação direta que fazia "Novas" significar
 * "disponível desde sempre".
 *
 * Módulo próprio, e não closure dentro do hook, porque a suíte roda em
 * `environment: 'node'`: o que não é função pura não é testável neste projeto.
 */
export const matchesJourneyFilter = (
  item: Matchable,
  filter: JourneyFilterId
): boolean => {
  if (filter === 'all') return true
  if (filter === 'new') return item.isNew
  return item.uiStatus === filter
}
